export const setOrderModalToStorage = () => {
  localStorage.setItem('orderModal', 'shown');
};
